import PropTypes, {InferProps} from "prop-types";
import {currentProfile, usePersonView, usePrincipal, useProfile} from "@betrue/front/services";
import {Profile} from "@betrue/shared/interfaces";
import {useEffect, useState} from "react";
import {PublicProfileConsentView} from "./public-profile-consent.view";

export const PublicProfileConsentPropsTypes = {
  acceptLabel: PropTypes.string,
  refuseLabel: PropTypes.string

}
export type PublicProfileConsentProps = InferProps<typeof PublicProfileConsentPropsTypes>

export const PublicProfileConsent = (props: PublicProfileConsentProps) => {

  const [viewPerson, viewProfile] = usePersonView()
  const [principal] = usePrincipal()

  const [, {updateProfile, updatePublicState}] = useProfile<Profile>(currentProfile)

  const [profile, setProfile] = useState<Profile>()

  useEffect(() => {
    if (viewProfile) {
      setProfile(viewProfile)

    }

  }, [viewProfile])

  const handleAdminConsent = (consent:boolean) => {
    updatePublicState(viewProfile.id, consent)
  }

  const handleToggle = (consent: string) => {
    if (consent != null) {
      setProfile({...viewProfile, publicConsent: consent === 'yes'})
      updateProfile({...viewProfile, publicConsent: consent === 'yes'})
    }

  }

  if (!viewProfile || !viewPerson || !profile || !principal) return (<></>)

  return (<PublicProfileConsentView
    {...props}
    onAdminConsent={handleAdminConsent}
    profile={profile}
    principal={principal}
    person={viewPerson} onToogle={handleToggle}/>);
}

PublicProfileConsent.propTypes = PublicProfileConsentPropsTypes
